<script>
  import { Router, Route } from "svelte-routing";
  import PasswordInput from "./PasswordInput.svelte";
  import Article from "./Article.svelte";
  import CarouselPre from "./CarouselPre.svelte";
  import CarouselPost from "./CarouselPost.svelte";
  import guests from "../data/guests.json";
  import templates from "../data/templates.json";

  let isAuthenticated = false;
  let articleContent = "";

  const passwords = {};
  guests.forEach((g) => {
    const hCode = g.Password;

    const template = g.Role !== undefined ? templates[0] : templates[1];
    const housingTemplate = templates[2];

    passwords[hCode] = template.Content.replace(
      "{{ personalized_suggestion }}",
      g.Role,
    )
      .replace("{{ name }}", g.Name)
      .replace(
        "{{ housing }}",
        g.Housing === "TRUE" ? housingTemplate.Content : "",
      );
  });

  function handleAuthentication(password) {
    if (password.detail.length > 0 && passwords[password.detail]) {
      isAuthenticated = true;
      articleContent = passwords[password.detail];
    } else {
      alert("Incorrect password");
    }
  }
</script>

<main>
  {#if isAuthenticated}
    <CarouselPost />
  {:else}
    <CarouselPre />
  {/if}
  <Router>
    {#if !isAuthenticated}
      <PasswordInput on:authenticate={handleAuthentication} />
    {:else}
      <Route path="/" component={Article} content={articleContent} />
      <Route path="/info" component={Article} content={"Test"} />
    {/if}
  </Router>
</main>

<style>
  main {
    color: rgb(200, 195, 188);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 2rem;
    width: 100vw;
    max-width: 800px;
    margin-top: 30px;
    min-height: 100vh;
    margin-bottom: 50px;
  }
</style>
